// TAMFARIS Undo bar — bilah tindak lanjut 5 detik lewat sonner toast.
// undoReverse: aksi sudah dikirim ke server; klik "Batalkan" memanggil onUndo (kebalikan aksi).
// undoDeferred: aksi menunggu 5 detik sebelum dieksekusi; klik "Batalkan" membatalkan, jika tidak dibatalkan onCommit dipanggil.
import { toast } from "sonner";
import { notify } from "./modal_center";

const DEFAULT_MS = 5000;

export function undoReverse({ title, message, undoLabel = "Batalkan", onUndo, duration = DEFAULT_MS, undoneTitle = "Aksi dibatalkan", undoneMessage = "" }) {
  const id = toast.success(title, {
    description: message || undefined,
    duration,
    action: {
      label: undoLabel,
      onClick: async () => {
        toast.dismiss(id);
        try { await onUndo(); toast.info(undoneTitle, undoneMessage ? { description: undoneMessage } : undefined); }
        catch (e) { notify.error({ title: "Batalkan gagal", message: e?.response?.data?.detail || "Silakan coba lagi." }); }
      },
    },
  });
  return id;
}

export function undoDeferred({ title, message, undoLabel = "Batalkan", onCommit, duration = DEFAULT_MS, committedTitle = "", cancelledTitle = "Aksi dibatalkan" }) {
  let cancelled = false;
  const id = toast.warning(title, {
    description: message || undefined,
    duration,
    action: {
      label: undoLabel,
      onClick: () => { cancelled = true; toast.dismiss(id); toast.info(cancelledTitle); },
    },
  });
  setTimeout(async () => {
    if (cancelled) return;
    try {
      await onCommit();
      if (committedTitle) toast.success(committedTitle);
    } catch (e) {
      notify.error({ title: "Aksi gagal dijalankan", message: e?.response?.data?.detail || "Silakan coba lagi." });
    }
  }, duration);
  return { cancel: () => { cancelled = true; toast.dismiss(id); } };
}
